var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "reserveBox" }, [
    _c("div", { staticClass: "column" }, [
      _c("div", { staticClass: "columnText2" }, [_vm._v(" 是否可拆分购买 ")]),
      _c("div", { staticStyle: { flex: "1", "text-align": "center" } }, [
        _c("div", { staticClass: "columnText3" }, [
          _vm._v(
            _vm._s(
              _vm.datas.isSplit
                ? _vm.resolutionList[_vm.datas.isSplit]
                : "未填写"
            )
          ),
        ]),
      ]),
    ]),
    _c("div", { staticClass: "column" }, [
      _c("div", { staticClass: "columnText2" }, [_vm._v(" 免费控房日期 ")]),
      _c("div", { staticStyle: { flex: "1", "text-align": "center" } }, [
        _c("div", { staticClass: "columnText3" }, [
          _vm._v(
            _vm._s(
              _vm.datas.optionTime
                ? _vm.dateFormatHm(_vm.datas.optionTime)
                : "未填写"
            )
          ),
        ]),
      ]),
    ]),
    _c("div", { staticClass: "column" }, [
      _c("div", { staticClass: "columnText4" }, [_vm._v(" 上架有效期 ")]),
      _c("div", { staticStyle: { flex: "1", "text-align": "center" } }, [
        _c("div", { staticClass: "columnText3" }, [
          _vm._v(
            _vm._s(
              _vm.datas.saleOptionTime
                ? _vm.dateFormatHm(_vm.datas.saleOptionTime)
                : "未填写"
            )
          ),
        ]),
      ]),
    ]),
    _c("div", { staticClass: "column" }, [
      _c("div", { staticClass: "columnText4" }, [_vm._v(" 有效期的解释 ")]),
      _c("div", { staticStyle: { flex: "1", "text-align": "center" } }, [
        _c("div", { staticClass: "columnText3" }, [
          _vm._v(
            _vm._s(
              _vm.datas.optionTimeExplain
                ? _vm.datas.optionTimeExplain
                : "未填写"
            )
          ),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }